// extracted by mini-css-extract-plugin
export var brand = "_7u-8";
export var compact = "_7u-5";
export var extraSmall = "_7u-6";
export var icon = "_7u-0";
export var large = "_7u-3";
export var light = "_7u-1";
export var medium = "_7u-4";
export var outline = "_7u-a";
export var primaryDark = "_7u-9";
export var primaryLight = "_7u-7";
export var primaryModern = "_7u-b";
export var success = "_7u-2";